/* eslint-disable no-param-reassign */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { EcommerceEcoupon } from '../../../api/cart/responses/cartResponses';

import { cartECouponAdapter } from '../../adapters/cartECouponAdapters';
import { setFullCart } from './cartHydrationActions';

export interface CartEcouponState extends EcommerceEcoupon {}

const cartECouponSlice = createSlice({
    name: 'ecoupons',
    initialState: cartECouponAdapter.getInitialState(),
    reducers: {
        setActiveState: (state, action: PayloadAction<ToggleECouponPayload>) => {
            cartECouponAdapter.updateOne(state, {
                id: action.payload.id,
                changes: {
                    active: action.payload.active,
                    isDirty: action.payload.isDirty,
                },
            });
        },
    },
    extraReducers: (builder) => {
        builder.addCase(setFullCart, (_state, action) => action.payload.ecoupons);
    },
});

export const { actions: cartECouponActions, reducer: cartECouponReducer } = cartECouponSlice;

export default cartECouponReducer;

export interface ToggleECouponPayload {
    id: string;
    active: boolean;
    isDirty: boolean;
}
